export default {
    OVER_18: 'o18',
    UNDER_13: 'u13',
    UNDER_16: 'u16',
    UNDER_18: 'u18',
    OVER_16: 'o16',
    OVER_13: 'o13',
};
